import { render, staticRenderFns } from "./DoorDescription.vue?vue&type=template&id=77b90dd3&scoped=true"
import script from "./DoorDescription.vue?vue&type=script&lang=ts"
export * from "./DoorDescription.vue?vue&type=script&lang=ts"
import style0 from "./DoorDescription.vue?vue&type=style&index=0&id=77b90dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b90dd3",
  null
  
)

export default component.exports